var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"desktop_side_menu_item text-center pointer"},[_c('router-link',{staticClass:"simple_link",attrs:{"to":_vm.url}},[_c('h3',{staticClass:"sub_text_color"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }